export const ALLOWED_IMAGE_STITCHING_MODES = ['kiss', 'hug'] as const
